import React from "react";
import Figure from "./Figure";
import MainImage from "./MainImage";
import ReactPlayer from "react-player";
import LatexRenderer from "./Latex";
import SyntaxHighlighter from 'react-syntax-highlighter'

//props/variables are fed in from page.js

//not currently in use or styled
const AuthorReference = ({ node }) => {
  if (node && node.author && node.author.name) {
    return <span>{node.author.name}</span>;
  }
  return <></>;
};

const serializers = {
  types: {
    authorReference: AuthorReference,
    mainImage: ({ node }) => <MainImage mainImage={node} />,
    videoEmbed: ({ node }) => <ReactPlayer className="mt-6 mb-6" url={node.url} controls />,
    // react-instagram-embed removed: it used Instagram's legacy oEmbed API,
    // shut down by Meta in 2020, and pinned react <=16. Render a plain link.
    instagram: ({ node }) => {
      if (!node.url) return null;
      return (
        <a href={node.url} target="_blank" rel="noopener noreferrer" className="container mx-auto mt-6 mb-6 block underline">
          View this post on Instagram
        </a>
      );
    },
    math: ({ node, isInline = false }) => <LatexRenderer isInline={isInline} latex={node.latex} />,
    code: ({node}) => <div>{node.code}</div>
  }
};

export default serializers;
